import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY;

export const decryptObject = (encryptedObj) => {
  try {
    if (!encryptedObj || !secretKey) {
      throw new Error("Invalid encrypted object or secret key");
    }

    const bytes = CryptoJS.AES.decrypt(encryptedObj, secretKey);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export const encryptObject = (obj) => {
  try {
    if (!obj || !secretKey) {
      throw new Error("Invalid object or secret key");
    }

    const stringData = JSON.stringify(obj);
    const encrypted = CryptoJS.AES.encrypt(stringData, secretKey).toString();
    return encrypted;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

// Checks the logged-in user's cached role permissions (see Sidebar.js, which
// keeps this fresh) for a given module/action -- used to hide action buttons
// (Edit/Delete/etc.) a role isn't allowed to use, not just gate page/menu
// visibility. The backend still enforces this independently on every
// request; this only controls what the UI shows.
export const hasPermission = (module, action) => {
  try {
    const raw = sessionStorage.getItem("permissions");
    if (!raw) return false;
    const permissions = JSON.parse(raw);
    return (permissions[module] || []).includes(action);
  } catch (error) {
    return false;
  }
};

export const base64ToFile = (base64Data, fileName, fileType) => {
  const byteString = atob(base64Data.split(",")[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }

  const fileBlob = new Blob([arrayBuffer], { type: fileType });
  return new File([fileBlob], fileName, { type: fileType });
};
